import { apiAdminInstance, apiUser } from "../Api/ApiInstance";

export async function VerifyPermission() {
  return await apiAdminInstance.get("api/nexus-main/permission/menu");
}

export async function VerifyUserLogged() {
  return await apiAdminInstance.get("api/nexus-main/permission/logged");
}

export async function VerifyClientLogged() {
  return await apiUser.get("api/nexus-main/permission/client/logged");
}
